import * as config from '../app/config';

const MODULE = config.API_GATEWAY_URL + 'datasets/views/';

export const RECENTLY_VIEWED_ENDPOINT = MODULE + "recently";
export const CREATE_DATASETS_ENDPOINT = MODULE + "create";